(function () {
  var MOBILE_MAX_WIDTH = 767;

  function isMobileViewport() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX_WIDTH + 'px)').matches;
  }

  function markPlaying(root) {
    root.classList.add('is-video-playing');
  }

  function getActiveVideo(root) {
    var mobileVideo = root.querySelector('[data-banner-video="mobile"]');
    var desktopVideo = root.querySelector('[data-banner-video="desktop"]');

    if (isMobileViewport()) {
      return mobileVideo || desktopVideo;
    }

    return desktopVideo || mobileVideo;
  }

  function getInactiveVideo(root, activeVideo) {
    var mobileVideo = root.querySelector('[data-banner-video="mobile"]');
    var desktopVideo = root.querySelector('[data-banner-video="desktop"]');

    if (activeVideo === desktopVideo) {
      return mobileVideo;
    }

    return desktopVideo;
  }

  function restoreVideoSource(video) {
    if (!video || video.dataset.bannerSrc) return;
    video.dataset.bannerSrc = video.getAttribute('src') || '';
  }

  function playVideo(video) {
    if (!video) return;

    video.muted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function activateVideo(root, activeVideo, inactiveVideo) {
    root.querySelectorAll('[data-banner-video]').forEach(function (video) {
      restoreVideoSource(video);
      video.classList.remove('is-active');
    });

    if (inactiveVideo) {
      inactiveVideo.pause();
      inactiveVideo.preload = 'none';

      if (inactiveVideo.getAttribute('src')) {
        inactiveVideo.removeAttribute('src');
        inactiveVideo.load();
      }
    }

    if (!activeVideo) return;

    activeVideo.classList.add('is-active');
    activeVideo.preload = 'auto';

    if (!activeVideo.getAttribute('src') && activeVideo.dataset.bannerSrc) {
      activeVideo.setAttribute('src', activeVideo.dataset.bannerSrc);
    }

    if (activeVideo.readyState === 0) {
      activeVideo.load();
    }

    activeVideo.addEventListener('playing', function () {
      markPlaying(root);
    }, { once: true });

    if (!activeVideo.paused && activeVideo.readyState >= 2) {
      markPlaying(root);
    }

    playVideo(activeVideo);
  }

  function initBannerVideo(root) {
    if (!root.querySelector('[data-banner-video]')) return;

    root.querySelectorAll('[data-banner-video]').forEach(restoreVideoSource);
    var initialActiveVideo = getActiveVideo(root);
    activateVideo(root, initialActiveVideo, getInactiveVideo(root, initialActiveVideo));

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        var activeVideo = getActiveVideo(root);
        activateVideo(root, activeVideo, getInactiveVideo(root, activeVideo));
      }, 200);
    });
  }

  function initWhiteHeader(root) {
    if (root.getAttribute('data-white-header') !== 'true') return;

    document.body.classList.add('header-no-fixed');

    var header = document.querySelector('.header-wrapper') || document.querySelector('.site-header');
    if (header) {
      header.classList.add('white-header');
    }
  }

  function initBannerScroll(root) {
    var button = root.querySelector('.sydney-marathon-2026-banner__button');
    if (!button) return;

    button.addEventListener('click', function (event) {
      var href = button.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;

      var target = document.querySelector(href);
      if (!target) return;

      event.preventDefault();

      var siteHeader = document.querySelector('.site-header') || document.querySelector('.header-wrapper');
      var headerHeight = siteHeader ? siteHeader.offsetHeight : 0;
      var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

      window.scrollTo({ top: targetPosition, behavior: 'smooth' });
    });
  }

  function initBanner(root) {
    if (!root || root.dataset.bannerInit === 'true') return;
    root.dataset.bannerInit = 'true';

    initWhiteHeader(root);
    initBannerVideo(root);
    initBannerScroll(root);
  }

  function boot() {
    document.querySelectorAll('sydney-marathon-2026-banner').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('sydney-marathon-2026-banner');
    if (root) initBanner(root);
  });

  if (!customElements.get('sydney-marathon-2026-banner')) {
    customElements.define('sydney-marathon-2026-banner', class SydneyMarathon2026Banner extends HTMLElement {});
  }
})();
